import { HomeService } from '@/services';
import {
  CONTENT_FETCH_ACTION, CONTENT_HOME_SET, SELECTED_REGION_ACTION, SELECTED_REGION_SET,
} from './types';

export default {
  async [CONTENT_FETCH_ACTION]({ commit }, { regionId }) {
    try {
      const content = await HomeService.fetchHomeCards(regionId);
      commit(CONTENT_HOME_SET, content);
    } catch (err) {
      console.error(err);
    }
  },

  async [SELECTED_REGION_ACTION]({ commit }, { selectedRegionTid }) {
    try {
      commit(SELECTED_REGION_SET, selectedRegionTid);
    } catch (err) {
      console.error(err);
    }
  },
};
